import { useEffect, useState, useCallback } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { Storefront, ClipboardText, ChatCircleDots, BellSimpleRinging } from "@phosphor-icons/react";

const TABS = [
  { to: "/app/marketplace", end: true, label: "Profils", icon: Storefront, testid: "mk-tab-profiles" },
  { to: "/app/marketplace/requests", label: "Demandes", icon: ClipboardText, testid: "mk-tab-requests" },
  { to: "/app/marketplace/messages", label: "Messages", icon: ChatCircleDots, testid: "mk-tab-messages" },
  { to: "/app/marketplace/alerts", label: "Mes alertes", icon: BellSimpleRinging, testid: "mk-tab-alerts" },
];

export default function MarketplaceLayout() {
  const [unread, setUnread] = useState(0);
  const location = useLocation();

  const loadUnread = useCallback(async () => {
    try {
      const { data } = await api.get("/marketplace/conversations/unread-count");
      setUnread(data.unread || 0);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { loadUnread(); }, [loadUnread, location.pathname]);

  return (
    <div data-testid="marketplace-layout">
      <nav className="flex items-center gap-1 border-b border-border mb-6 overflow-x-auto" data-testid="marketplace-subnav">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
            className={({ isActive }) => `relative flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors ${isActive ? "border-accent text-fg" : "border-transparent text-muted hover:text-fg"}`}>
            <t.icon size={16} />
            {t.label}
            {t.label === "Messages" && unread > 0 && (
              <span data-testid="mk-unread-badge" className="ml-1 min-w-[18px] h-[18px] px-1 rounded-full bg-accent text-black text-[11px] font-bold flex items-center justify-center">{unread}</span>
            )}
          </NavLink>
        ))}
      </nav>
      <Outlet context={{ refreshUnread: loadUnread }} />
    </div>
  );
}
